import { WhatsAppOutlined } from "@ant-design/icons";
import { Button } from "antd";

/**
 * Tombol reminder WA (hijau + ikon WhatsApp), konsisten modal detail & tabel Semua Jadwal.
 */
const ScheduleReminderButton = ({
  onClick,
  children,
  "aria-label": ariaLabel,
  size = "middle",
}) => {
  return (
    <Button
      type="primary"
      size={size}
      icon={<WhatsAppOutlined />}
      aria-label={ariaLabel}
      onClick={(e) => {
        e?.stopPropagation?.();
        onClick?.(e);
      }}
      style={{
        backgroundColor: "#25D366",
        borderColor: "#25D366",
      }}
      className="hover:!border-[#20bd5a] hover:!bg-[#20bd5a]"
    >
      {children}
    </Button>
  );
};

export default ScheduleReminderButton;
